import { useState, useEffect } from 'react'
import { Grid } from '@mui/material'

import Dialog from './Dialog'
import GridCheckbox from './GridCheckbox'
import { useTeamName } from '../hooks/utils-functions'
import { titlesProvvedimenti } from '../settings/settings'

const DialogSanzioneReferto = ({
  open,
  handleClose,
  triggerFunction,
  gara,
}) => {
  const [sanzioneReferto, setSanzioneReferto] = useState()
  const [sanzioneMail, setSanzioneMail] = useState()

  const squadraCasaName = useTeamName(gara?.squadraCasaID)

  useEffect(() => {
    if (open) setSanzioneReferto(gara?.squadraCasaSanzionataPerReferto)
  }, [gara, open])

  useEffect(() => {
    if (!open) {
      setSanzioneReferto()
      setSanzioneMail()
    }
  }, [open])

  return (
    <Dialog
      open={open}
      handleClose={handleClose}
      triggerFunction={() => triggerFunction(sanzioneReferto, sanzioneMail)}
      title={titlesProvvedimenti.titleEditSanzioneReferto}
      textUndo='Annulla'
      textConfirm='Conferma'
      maxWidth='md'
    >
      <Grid container spacing={3} sx={{ width: '100%' }}>
        {((!gara || gara.length === 0) && (
          <Grid size={12}>Nessuna partita selezionata.</Grid>
        )) || (
          <Grid container sx={{ width: '100%' }}>
            <Grid size={12}>
              Il presente modulo permette di sanzionare la squadra di casa per
              non aver inviato il referto della gara nei tempi consentiti.
              <br />
              La casella "sanziona squadra di casa" fa colorare di verde la "€"
              presente nell'elenco dei referti inviati in ritardo, a segnalare
              che la squadra è stata sanzionata.
              <br />
              La casella "invia mail con sanzione" fa partire una mail che
              avvisa la società del provvedimento disciplinare.
            </Grid>
            {!!gara && (
              <Grid container alignItems='center' sx={{ width: '100%' }}>
                <Grid size={{ xs: 12, md: 4 }}>
                  <center>
                    Gara numero: <b>{gara.numeroGara}</b>
                  </center>
                </Grid>
                <Grid size={{ xs: 12, md: 8 }}>
                  <center>
                    Squadra di casa: <b>{squadraCasaName}</b>
                  </center>
                </Grid>
              </Grid>
            )}
            {!!gara && (
              <Grid container sx={{ width: '100%' }}>
                <GridCheckbox
                  label='Sanziona squadra di casa'
                  value={!!sanzioneReferto}
                  onChange={(_, x) => setSanzioneReferto(x)}
                />
                <GridCheckbox
                  label='Invia mail con sanzione'
                  value={!!sanzioneMail}
                  onChange={(_, x) => setSanzioneMail(x)}
                />
              </Grid>
            )}
          </Grid>
        )}
      </Grid>
    </Dialog>
  )
}

export default DialogSanzioneReferto
